import activityLog from './activityLog'
import address from './address'
import auth from './auth'
import categories from './categories'
import dashboard from './dashboard/main'
import editor from './editor'
import files from './files'
import formProcesses from './formProcesses/main'
import forms from './forms'
import fundingPrograms from './fundingPrograms/main'
import globalSearch from './globalSearch'
import jugendzaehlt from "./jugendzaehlt"
import lifecycleLog from './lifecycleLog'
import loginProviders from './loginProviders/main'
import mailTemplates from './mailTemplates/main'
import mails from './mails/main'
import menu from './menu'
import news from './news'
import notifications from './notifications'
import organisationUsers from './organisationUsers/main'
import organisations from './organisations/main'
import pageTitle from './pageTitle'
import parishes from './parishes/main'
import paymentRuns from './paymentRuns/main'
import payments from './payments/main'
import process from './process/main'
import processes from './processes/main'
import regionParishes from './regionParishes/main'
import regions from './regions/main'
import requestLog from './requestLog'
import roles from './roles/main'
import secret from './secret'
import settings from './settings'
import signature from './signature'
import sportbizz from "./sportbizz"
import statisticForms from './statisticForms/main'
import statisticProcessTransfers from './statisticProcessTransfers/main'
import statisticProcesses from './statisticProcesses/main'
import statisticSurveyPeriods from './statisticSurveyPeriods/main'
import statisticSurveys from './statisticSurveys/main'
import statusNotifications from './statusNotifications/main'
import statuses from './statuses/main'
import table from './table/main'
import testUsers from './testUsers/main'
import userOrganisations from './userOrganisations/main'
import users from './users/main'
import usersFrontend from './usersFrontend/main'
import years from './years'

export default {
    localeHint: 'Dies ist die deutsche Version der Website.',
    canNotAccessRoute: 'Du hast keine Berechtigung, auf diese Seite zu gehen.',

    serverError: 'Es liegt serverseitig ein Fehler vor.',
    serverErrorSupport: 'Dieser Fehler wurde bereits im Hintergrund an den Support gemeldet. Sie helfen uns, wenn Sie kurz beschreiben, in welcher Situation dieser Fehler aufgetreten ist und an support{\'@\'}oase-bw.de senden.',
    serverErrorThankYou: 'Vielen Dank für Ihre Mithilfe.',

    invalidRequestData: 'Die Anfrage enthält ungültige Daten.',
    modelDoesNotExist: 'Die angeforderte Ressource existiert nicht.',
    generalRequestError: 'Die Anfrage konnte nicht verarbeitet werden.',
    unknownError: 'Unbekannter Fehler',

    baseData: 'Daten',
    pleaseSelect: 'Bitte wählen...',
    noResults: 'Keine Ergebnisse',
    noData: 'Keine Daten',
    required: 'Pflichtfeld',

    resourceDoesNotExist: 'Der aufgerufene Eintrag existiert nicht, oder du hast keine Berechtigung diesen abzurufen.',
    confirmLeave: 'Du hast nicht gespeicherte Änderungen. Möchtest du die Seite wirklich verlassen?',

    abort: 'Abbrechen',
    close: 'Schließen',
    delete: 'Löschen',
    reset: 'Zurücksetzen',
    back: 'Zurück',
    save: 'Speichern',
    discard: 'Verwerfen',
    error: 'Fehler',
    open: 'Öffnen',
    show: 'Anzeigen',
    more: 'Weiteres',
    change: 'Ändern',
    add: 'Hinzufügen',
    attach: 'Verknüpfen',
    detach: 'Verknüpfung lösen',
    welcome: 'Willkommen!',
    caution: 'Achtung',
    showMore: 'Mehr anzeigen',
    showLess: 'Weniger anzeigen',
    yes: 'Ja',
    no: 'Nein',
    name: 'Name',

    locales: {
        de: 'Deutsch', en: 'English'
    },

    activityLog,
    address,
    auth,
    categories,
    dashboard,
    editor,
    files,
    formProcesses,
    forms,
    fundingPrograms,
    globalSearch,
    jugendzaehlt,
    lifecycleLog,
    loginProviders,
    mailTemplates,
    mails,
    menu,
    news,
    notifications,
    organisationUsers,
    organisations,
    pageTitle,
    parishes,
    paymentRuns,
    payments,
    process,
    processes,
    regionParishes,
    regions,
    requestLog,
    roles,
    secret,
    settings,
    signature,
    sportbizz,
    statisticForms,
    statisticProcesses,
    statisticProcessTransfers,
    statisticSurveyPeriods,
    statisticSurveys,
    statusNotifications,
    statuses,
    table,
    testUsers,
    userOrganisations,
    users,
    usersFrontend,
    years,
}

